import { createSelector } from 'reselect'

const getAdminOnboardingIsAdmin = state => state.adminOnboarding.isAdmin

const adminOnboardingIsAdminSelector = createSelector(
	[getAdminOnboardingIsAdmin],
	adminOnboardingIsAdmin => adminOnboardingIsAdmin
)

export default adminOnboardingIsAdminSelector
